import '@hotwired/turbo-rails'
import '~/shared/turbo_csp_nonce'
import { Application } from '@hotwired/stimulus'
import { registerControllers } from 'stimulus-vite-helpers'

import '~/shared/font.js'
import '~/auth/styles/auth.css'

// init Stimulus
const app = Application.start()
console.log('Creyos ⚡️ 🧠')

// import shared controllers
const sharedControllers = import.meta.glob(
  '../shared/controllers/**/*_controller.{ts,js}',
  { eager: true }
)
registerControllers(app, sharedControllers)

const authControllers = import.meta.glob(
  '../auth/controllers/**/*_controller.{ts,js}',
  { eager: true }
)
registerControllers(app, authControllers)
